<template>
  <div class="qc" v-if="quickconnects">

         <v-layout justify-center >
          <QCCard :qc="quickconnects" />
         </v-layout>

  </div>
</template>
<script>
import QCCard from "@/components/QCCard";
import EventService from '@/services/EventService.js'; 
export default {
  name: "TodaysQC",
  components: {
    QCCard
  },
  data() {
    return {
      quickconnect: {},
      quickconnects: [],
      today: '',
    };
  },
  mounted() {
    this.getTodaysQC(); 
  },

     computed: {
  user(){
    return this.$store.state.user
  }
   },

  methods: {

    async getTodaysDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
      return this.today
    },
  
    async getTodaysQC() {
      this.today = await this.getTodaysDate();
      const quickconnects = 
      await EventService.getTodaysQuickConnect(this.today)
      this.quickconnects = quickconnects
    }
  }
}

</script>
<style lang="scss" scoped>
.layout {
  width: 75vw;
}
.qc {
  margin-top: 15px;
  text-align: center;
.newmembtn {
  margin-bottom: 5px;
}
}
</style>